<template>
  <template v-if="props.multiple">
    <input
      v-for="value in props.selectedValues"
      :key="value || 'null'"
      type="hidden"
      :name="`${props.name}[]`"
      :value="value"
    />
  </template>
  <input
    v-else
    type="hidden"
    :name="props.name"
    :value="props.selectedValues[0] || ''"
  />
</template>

<script setup lang="ts">
import { DSOptionValue } from "@/src/design_system/form_elements/shared/types/option";

const props = defineProps<{
  name: string;
  selectedValues: DSOptionValue[];
  multiple: boolean;
}>();
</script>
